/* =========================
   Tanna – hide GTY WhatsApp when mobile menu is open (Ella/Halo)
   ========================= */
(function () {
  const root = document.documentElement;

  function isVisible(el) {
    if (!el) return false;
    const st = window.getComputedStyle(el);
    if (st.display === "none" || st.visibility === "hidden" || st.opacity === "0") return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function isMenuOpen() {
    const b = document.body;
    const cls = (b && b.className) ? b.className : "";

    // 1) Clase frecvente când se deschide drawer-ul / meniul
    if (
      cls.includes("menu-open") ||
      cls.includes("drawer-open") ||
      cls.includes("navigation-open") ||
      cls.includes("overflow-hidden") ||
      cls.includes("open-menu") ||
      cls.includes("openMenu") ||
      cls.includes("open_menu") ||
      cls.includes("openMobileMenu") ||
      cls.includes("halo-open") ||
      cls.includes("modal-open")
    ) return true;

    // 2) Ella/Halo (foarte des au "halo-" pentru drawer/sidebars)
    const haloOpen =
      document.querySelector(".halo-sidebar.is-open, .halo-sidebar.open, .halo-sidebar.active, .halo-sidebar--open") ||
      document.querySelector(".halo-menu-mobile.is-open, .halo-menu-mobile.open, .halo-menu-mobile.active") ||
      document.querySelector(".halo-drawer.is-open, .halo-drawer.open, .halo-drawer.active") ||
      document.querySelector(".halo-overlay.is-open, .halo-overlay.open, .halo-overlay.active");

    if (haloOpen && isVisible(haloOpen)) return true;

    // 3) Shopify common drawers
    const shopifyDrawer =
      document.querySelector("#MenuDrawer, #menu-drawer, .menu-drawer, .drawer, .nav-drawer, .mobile-nav");
    if (shopifyDrawer && isVisible(shopifyDrawer)) return true;

    // 4) Buton hamburger (aria-expanded)
    if (document.querySelector('[aria-expanded="true"][aria-controls*="menu" i]')) return true;
    if (document.querySelector('[aria-expanded="true"][aria-controls*="drawer" i]')) return true;

    // 5) Fallback: dacă body are scroll blocat (multe teme fac asta)
    // (nu e perfect, dar ajută)
    if (b && (b.style.overflow === "hidden" || cls.includes("no-scroll"))) return true;

    return false;
  }

  function sync() {
    root.classList.toggle("tanna-menu-open", isMenuOpen());
  }

  function start() {
    sync();

    // Observă schimbări de clasă pe body
    new MutationObserver(sync).observe(document.body, {
      attributes: true,
      attributeFilter: ["class", "style"]
    });

    // Observă apariția overlay/drawer în DOM (uneori e lazy)
    new MutationObserver(sync).observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    document.addEventListener("click", () => setTimeout(sync, 0), true);
    window.addEventListener("resize", () => setTimeout(sync, 0), { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

